import { render, staticRenderFns } from "./centreRight1.vue?vue&type=template&id=199e6bbb"
import script from "./centreRight1.vue?vue&type=script&lang=js"
export * from "./centreRight1.vue?vue&type=script&lang=js"
import style0 from "./centreRight1.vue?vue&type=style&index=0&id=199e6bbb&prod&lang=scss"
import style1 from "./centreRight1.vue?vue&type=style&index=1&id=199e6bbb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports